import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { eventosService, type DadosEvento } from "@/modules/eventos/services/eventosService";

const QUERY_KEY_EVENTOS = ["eventos"];

/** Eventos podem gerar reservas e aparecem no Calendário — invalidamos os três. */
function useInvalidarEventos() {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({ queryKey: QUERY_KEY_EVENTOS });
    queryClient.invalidateQueries({ queryKey: ["reservas"] });
    queryClient.invalidateQueries({ queryKey: ["calendario"] });
  };
}

export function useEventos() {
  return useQuery({ queryKey: QUERY_KEY_EVENTOS, queryFn: eventosService.listar });
}

export function useCriarEvento() {
  const invalidar = useInvalidarEventos();
  return useMutation({
    mutationFn: (dados: DadosEvento) => eventosService.criar(dados),
    onSuccess: invalidar,
  });
}

export function useAtualizarEvento() {
  const invalidar = useInvalidarEventos();
  return useMutation({
    mutationFn: ({ id, dados }: { id: string; dados: DadosEvento }) =>
      eventosService.atualizar(id, dados),
    onSuccess: invalidar,
  });
}

export function useCancelarEvento() {
  const invalidar = useInvalidarEventos();
  return useMutation({
    mutationFn: ({ id, motivo }: { id: string; motivo: string }) => eventosService.cancelar(id, motivo),
    onSuccess: invalidar,
  });
}

export function useAprovarEvento() {
  const invalidar = useInvalidarEventos();
  return useMutation({
    mutationFn: (id: string) => eventosService.aprovar(id),
    onSuccess: invalidar,
  });
}

export function useRejeitarEvento() {
  const invalidar = useInvalidarEventos();
  return useMutation({
    mutationFn: ({ id, motivo }: { id: string; motivo: string }) => eventosService.rejeitar(id, motivo),
    onSuccess: invalidar,
  });
}
